<template>
    <v-sheet>
        <v-radio-group v-model="form.entrance.type" row hide-details @change="emit">
            <template v-for="item in items">
                <v-radio :label="item.text" :value="item.value" :key="item.value" />
            </template>
        </v-radio-group>

        <v-expand-transition>
            <v-sheet v-show="isTypeInterviewees">
                <v-autocomplete v-model="form._interviewees" v-bind="attrs_input" style="margin-top: 12px" @input="emit" />
            </v-sheet>
        </v-expand-transition>
    </v-sheet>
</template>

<script>
import { attrs_input } from "@/assets/variables/attrs";
import { initInterview } from "@/assets/variables/inits";
import { INTERVIEW_ENTRANCE_TYPES } from "@/assets/variables/constants";

export default {
    props: {
        value: { type: Object, default: initInterview },
    },

    data: () => ({
        form: initInterview(),

        items: Object.values(INTERVIEW_ENTRANCE_TYPES),
        attrs_input,
    }),
    computed: {
        isTypeInterviewees() {
            return this.form.entrance.type == INTERVIEW_ENTRANCE_TYPES.INTERVIEWEES.value;
        },
    },
    methods: {
        sync() {
            this.form = initInterview(this.value);
        },
        emit() {
            if (!this.isTypeInterviewees) {
                this.form._interviewees = [];
            }
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style>
</style>